import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-32 text-center" data-id="element-506" data-mp="w3ztfmzgnvxh">
      <h1 className="font-display text-4xl uppercase tracking-display" data-id="element-507" data-mp="105us0jq0bv7k">Deze pagina bestaat niet</h1>
      <p className="mt-3 text-muted" data-id="element-508" data-mp="154xy87hq47h4">Misschien is het product verplaatst. Bekijk onze bestsellers.</p>
      <Link to="/collectie/bestsellers" className="mt-8 inline-flex h-12 items-center rounded-full bg-ink px-6 text-sm font-medium text-canvas hover:bg-berry" data-id="element-509" data-mp="1a426mvwtq16e">
        Naar bestsellers
      </Link>
    </div>;
}